import { getAccessReviewResource as apiGetAccessReviewResource } from "api/accessReviewResources";
import constate from "constate";
import { useLoadingState } from "hooks/useLoadingState";
import { Map } from "immutable";
import { type AccessReviewResourceModel } from "models/AccessReviewResourceModel";
import { useCallback, useState } from "react";

const useAccessReviewResources = () => {
  const [accessReviewResources, setAccessReviewResources] = useState(Map<string, AccessReviewResourceModel>());
  const { isLoading: isGetLoading, withLoader: withGetLoader } = useLoadingState();

  const getAccessReviewResource = useCallback(
    async (id: string): Promise<AccessReviewResourceModel | null> => {
      if (!id) return null;

      const accessReviewResource = await withGetLoader(apiGetAccessReviewResource(id));
      setAccessReviewResources((current) => current.set(id, accessReviewResource));
      return accessReviewResource;
    },
    [withGetLoader],
  );

  const updateResource = useCallback((id: string, resource: AccessReviewResourceModel) => {
    setAccessReviewResources((current) => current.set(id, resource));
  }, []);

  return {
    actions: {
      getAccessReviewResource,
      updateResource,
    },
    state: { accessReviewResources, isGetLoading },
  };
};

export const [AccessReviewResourcesProvider, useAccessReviewResourcesContext] = constate(useAccessReviewResources);
